import session from '@/shared/session'

// initial state
const state = {
}

// getters
const getters = {}
const data = {}
// actions
const actions = {
	strengthOverview ({},data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/strength/', { params: data,
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	strengthDetail ({},data) {
		return new Promise((resolve, reject) => {
			session.get(`/api/workouts/strength/${data.id}/`, {
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	strengthCreate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.post('api/workouts/strength/', data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	strengthUpdate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.put(`/api/workouts/strength/${data.id}/`, data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	strengthRemove ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/strength/partial_update_delete/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	filterStrength ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/strength/get_filtered_strength/', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
	strengthStatusUpdate ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/strength/partial_update_status/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
	activeStrenghts({ commit }) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/strength/get_active_strengths/', {
				headers: {
					"Authorization": "Token " + localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data;
				resolve(data);
			})
			.catch(errors => {
				resolve(errors.response.data);
			});
		});
	},	

}

// mutations
const mutations = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
